var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useMemo, useState } from 'react';
import { apiGetOneProffitSearchInformation } from '../../../../actions/ProffitSearchAction';
import { apiGetProffitSearchGroup, apiUpdateProffitSearchGroupAccount, } from '../../../../actions/ProffitSearchGroupAction';
import { apiGetOneProfile } from '../../../../actions/ProfileActions';
import { notify, wrapDispatch, wrapNotifyError } from '../../../action';
import { useBoolState } from '../../useHook';
const useMyPageAccountEdit = (unmountRef, list) => {
    // フォーム表示前の確認モーダル制御
    const { boolState: isShowEditModal, changeFalse: hideEditModal, changeTrue: showEditModal, } = useBoolState(false);
    // 編集時のフォーム表示制御
    const { boolState: isShowEditForm, changeFalse: hideEditForm, changeTrue: showEditForm, } = useBoolState(false);
    /**
     * 各レコードの編集時に参照するinitialValues
     * @type {{}}
     */
    const defaultInitialValuesObj = useMemo(() => {
        const obj = {};
        list.forEach((v) => {
            obj[v.id] = {
                initialValues: {
                    email: v.email,
                    id: v.id,
                },
                isEditable: false,
            };
        });
        return obj;
    }, [list]);
    const [initialValuesObj, changeInitialValuesObj] = useState(defaultInitialValuesObj);
    // 編集しようとしているメールアドレス（確認モーダル内のテキストで参照）
    const [selectedRow, changeSelectedRow] = useState({});
    /**
     * 各行のメールアドレスの編集状態を対象のIDで切り替える
     * @type {(function(*, *): void)|*}
     */
    const changeEditableRow = useCallback((id, values) => {
        changeInitialValuesObj((prevState) => (Object.assign(Object.assign({}, prevState), { [id]: Object.assign(Object.assign({}, prevState[id]), values) })));
    }, [changeInitialValuesObj]);
    /**
     * テーブル内のメンバー変更をクリックした時のイベント（モーダル表示）
     * @type {(function(*): void)|*}
     */
    const onClickRowEdit = useCallback((e) => {
        const { value } = e.currentTarget;
        const id = parseInt(value, 10);
        const row = list.find((v) => v.id === id) || {};
        changeSelectedRow(row);
        showEditModal();
    }, [changeSelectedRow, list, showEditModal]);
    /**
     * テーブル内の編集キャンセルをクリックした時のイベント
     * @type {(function(*))|*}
     */
    const onClickRowCancel = useCallback((e) => {
        const { value } = e.currentTarget;
        const id = parseInt(value, 10);
        changeEditableRow(id, { isEditable: false });
    }, [changeEditableRow]);
    /**
     * モーダル内のメンバー変更をクリックした時のイベント（編集フォーム表示）
     * @type {(function(*))|*}
     */
    const onClickModalEdit = useCallback((e) => {
        const { value } = e.currentTarget;
        const id = parseInt(value, 10);
        changeEditableRow(id, { isEditable: true });
        hideEditModal();
    }, [hideEditModal, changeEditableRow]);
    /**
     * アカウント編集のフォームをsubmitした時のイベント
     * @type {(function(*, *, *): Promise<void>)|*}
     */
    const onSubmit = useCallback((formValues, formDispatch, formProps) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            const { email, id } = formValues;
            const { initialValues } = formProps;
            // 編集されないままsubmitされた場合、そのまま編集フォームを閉じる
            if (email === initialValues.email) {
                changeEditableRow(id, { isEditable: false });
                return;
            }
            // アカウントを更新
            const { payload: { id: newId }, } = yield wrapDispatch(formDispatch, apiUpdateProffitSearchGroupAccount(id, { email }));
            // 各種データを引き直す
            yield Promise.all([
                wrapDispatch(formDispatch, apiGetProffitSearchGroup()),
                wrapDispatch(formDispatch, apiGetOneProffitSearchInformation()),
                wrapDispatch(formDispatch, apiGetOneProfile()),
            ]);
            if (!unmountRef.current) {
                hideEditForm();
                // 編集後の状態に更新
                changeEditableRow(newId, {
                    initialValues: { email, id: newId },
                    isEditable: false,
                });
                notify('アカウントを更新しました');
            }
        }));
    }), [changeEditableRow, hideEditForm, unmountRef]);
    return {
        email: selectedRow.email,
        hideEditForm,
        hideEditModal,
        id: selectedRow.id,
        initialValuesObj,
        isShowEditForm,
        isShowEditModal,
        onClickModalEdit,
        onClickRowCancel,
        onClickRowEdit,
        onSubmit,
        showEditForm,
        showEditModal,
    };
};
export const useMyPageAccountList = {
    useMyPageAccountEdit,
};
export default useMyPageAccountList;
